<template>
  <div class="flex items-center justify-start gap-2">
    <div class="flex flex-col gap-2">
      <status-progress-exec-trail-component
        v-for="(order, index) in orders"
        :key="index"
        :trail="order"
      />
    </div>
    <dl class="flex w-16 flex-col">
      <template>
        <dt>
          {{ calcTypeDict }}
        </dt>
        <dd class="font-semibold text-gray-300" v-if="entry">
          {{ entry }}
        </dd>
        <dd class="font-semibold text-gray-300" v-else>-</dd>
        <!-- <span>
          {{ calc_type }}
        </span> -->
      </template>
    </dl>
    <!-- <button
      @click="
        $emit('openModalClientOrders', {
          exec_trail_id: execTrailId,
          account_id: accountId,
          account_number: accountNumber,
          broker_name: brokerName,
          trail_order_ids: orders.map((item) => item.trail_order_id),
          trail_order_goal: trailOrderGoal,
        })
      "
    >
      <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4.09792 13.6062H10.4V12.2312H4.09792V13.6062ZM4.09792 9.6875H13.4021V8.3125H4.09792V9.6875ZM4.09792 5.76875H13.4021V4.39375H4.09792V5.76875ZM1.875 17.25C1.50833 17.25 1.1875 17.1125 0.9125 16.8375C0.6375 16.5625 0.5 16.2417 0.5 15.875V2.125C0.5 1.75833 0.6375 1.4375 0.9125 1.1625C1.1875 0.8875 1.50833 0.75 1.875 0.75H15.625C15.9917 0.75 16.3125 0.8875 16.5875 1.1625C16.8625 1.4375 17 1.75833 17 2.125V15.875C17 16.2417 16.8625 16.5625 16.5875 16.8375C16.3125 17.1125 15.9917 17.25 15.625 17.25H1.875ZM1.875 15.875H15.625V2.125H1.875V15.875ZM1.875 2.125V15.875V2.125Z"
          fill="#0694E6"
        />
      </svg>
    </button> -->
  </div>
</template>

<script>
import StatusProgressExecTrailComponent from "./status-progress-exec-trail.component.vue";

export default {
  components: {
    StatusProgressExecTrailComponent,
  },
  props: {
    calc_type: {
      type: String,
    },
    entry: {
      type: Number,
    },
    execTrailId: {
      type: Number,
    },
    accountId: {
      type: Number,
    },
    accountNumber: {
      type: Number,
    },
    brokerName: {
      type: String,
    },
    orders: {
      type: Array,
      default: [],
    },
    trailOrderGoal: {
      type: String,
    },
  },
  computed: {
    calcTypeDict() {
      switch (this.calc_type) {
        case "FACTOR":
          return "Fator";
        case "DIFFERENCE":
          return "Diferença";
        case "LINEAR_FUNCTION":
          return "Resíduo";
      }
    },
  },
};
</script>

<style></style>
